export default function initializeVentiTabs() {
    document.querySelectorAll('.venti-tabs').forEach(function (block) {
        new VentiTabsClass(block);
    });
}

class VentiTabsClass {
    constructor(block) {
        this.block = block;
        this.navItems = [];
        this.init();
    }


    init() {
        Array.from(this.block.children).forEach(function (child) {
            if (child.tagName.toLowerCase() === 'section' && child.hasAttribute('data-nav-title')) {
                this.navItems.push(child);
            }
        }.bind(this));
        if(this.navItems.length === 0) {
            return;
        }
        this.renderNav();
        this.renderMobileNav();
        this.activateTab(this.block.querySelector('.venti-tabs__nav-item'));
         this.blockListeners();

    }

    renderNav() {
        this.block.querySelector('.venti-tabs__nav').innerHTML = this.navItems.map(function (section) {
            if(section.dataset.navTitle === '') {
                return '';
            }
            return `<button class="venti-tabs__nav-item" data-target="${section.id}" role="link">${section.dataset.navTitle}</button>`;
        }).join('');

        this.actionsNav();
    }

    actionsNav() {
        this.block.querySelector('.venti-tabs__nav').addEventListener('click', function (e) {
            if(e.target.classList.contains('venti-tabs__nav-item')) {
                e.preventDefault();
                this.activateTab(e.target);
            }
        }.bind(this));
    }

    renderMobileNav() {
        const mobileNavSelect = document.createElement('select');
        mobileNavSelect.classList.add('venti-tabs__mobile-nav');
        mobileNavSelect.innerHTML = this.navItems.map(function (section) {
            if(section.dataset.navTitle === '') {
                return '';
            }
            return `<option value="${section.id}">${section.dataset.navTitle}</option>`;
        }).join('');
        this.block.querySelector('.venti-tabs__mobile-nav-container').appendChild(mobileNavSelect);
        this.addOverflowScrollNav();
        this.actionsMobileNav();
    }

    // dodaje strzałki zamiast poziomego scrolla jeśli szerokość mniejsza niż zawartość
    addOverflowScrollNav() {
        const navContainer = this.block.querySelector('.venti-tabs__nav-container');
        const nav = this.block.querySelector('.venti-tabs__nav');
        if(nav.scrollWidth > nav.clientWidth) {
            navContainer.classList.add('with-overflow');
            navContainer.classList.add('overflow-hidden');
            const arrowLeft = document.createElement('div');
            arrowLeft.classList.add('venti-tabs__nav-arrow', 'venti-tabs__nav-arrow--left');
            arrowLeft.classList.add('venti-tabs__nav-arrow', 'venti-tabs__nav-arrow--hidden');
            arrowLeft.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002" xml:space="preserve">\n' +
                '    <path d="M388.425 241.951 151.609 5.79c-7.759-7.733-20.321-7.72-28.067.04-7.74 7.759-7.72 20.328.04 28.067l222.72 222.105-222.728 222.104c-7.759 7.74-7.779 20.301-.04 28.061a19.8 19.8 0 0 0 14.057 5.835 19.79 19.79 0 0 0 14.017-5.795l236.817-236.155c3.737-3.718 5.834-8.778 5.834-14.05s-2.103-10.326-5.834-14.051z"/>\n' +
                '</svg>';
            const arrowRight = document.createElement('div');
            arrowRight.classList.add('venti-tabs__nav-arrow', 'venti-tabs__nav-arrow--right');
            arrowRight.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002" xml:space="preserve">\n' +
                '    <path d="M388.425 241.951 151.609 5.79c-7.759-7.733-20.321-7.72-28.067.04-7.74 7.759-7.72 20.328.04 28.067l222.72 222.105-222.728 222.104c-7.759 7.74-7.779 20.301-.04 28.061a19.8 19.8 0 0 0 14.057 5.835 19.79 19.79 0 0 0 14.017-5.795l236.817-236.155c3.737-3.718 5.834-8.778 5.834-14.05s-2.103-10.326-5.834-14.051z"/>\n' +
                '</svg>';
            navContainer.prepend(arrowLeft);
            navContainer.append(arrowRight);

            // Akcja scrolla
            arrowLeft.addEventListener('click', function () {
                nav.scrollLeft -= 150;
            });
            arrowRight.addEventListener('click', function () {
                nav.scrollLeft += 150;
            });

            nav.scrollLeft = 0;


            // Wykrywanie gdzie ustawiony scroll i ukrywanie/pokazywanie strzałek
            nav.addEventListener('scroll', function () {
                if(nav.scrollLeft === 0) {
                    navContainer.querySelector('.venti-tabs__nav-arrow--left').classList.add('venti-tabs__nav-arrow--hidden');
                } else {
                    navContainer.querySelector('.venti-tabs__nav-arrow--left').classList.remove('venti-tabs__nav-arrow--hidden');
                }
                if(nav.scrollLeft + nav.clientWidth >= nav.scrollWidth) {
                    navContainer.querySelector('.venti-tabs__nav-arrow--right').classList.add('venti-tabs__nav-arrow--hidden');
                } else {
                    navContainer.querySelector('.venti-tabs__nav-arrow--right').classList.remove('venti-tabs__nav-arrow--hidden');
                }
            });

        } else {
            navContainer.classList.remove('with-overflow');
            navContainer.classList.remove('overflow-hidden');

        }

    }

    actionsMobileNav() {
        this.block.querySelector('.venti-tabs__mobile-nav').addEventListener('change', function (e) {
            this.activateTab(this.block.querySelector('.venti-tabs__nav-item[data-target="' + e.target.value + '"]'));
        }.bind(this));
    }

    activateTab(target) {
        target.closest('.venti-tabs__nav').querySelectorAll('.venti-tabs__nav-item').forEach(function (link) {
            link.classList.remove('active');
        });
        target.classList.add('active');
        this.navItems.forEach(function (section) {
            section.classList.remove('active');
            if(section.id === target.dataset.target) {
                section.classList.add('active');
            }
        });
        this.runIndicator(target);
    }

    runIndicator(target) {
        const indicator = this.block.querySelector('.venti-tabs__nav-indicator');
        indicator.style.width = target.offsetWidth + 'px';
        indicator.style.left = target.offsetLeft + 'px';

    }

    blockListeners() {
        window.addEventListener('activate_tab', e => {
            if(e.detail.target) {
                const targetElement = this.block.querySelector('.venti-tabs__nav-item[data-target="' + e.detail.target + '"]');
                if(!targetElement) {
                    return;
                }
                targetElement.click();
            }
        });
    }



}
